import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EmployerAdditionalContactFormGroup } from '../../../../../forms/employer-additional-contact-form-group';
import { EmployerRecordAdditionalContactFormGroup } from '../../../../../forms/employer-record-additional-contact-form-group';
import { PhoneDropdownItem } from '../../../../../models/shared/phone-dropdown-item';
import { CANADA_COUNTRY_ID } from '../../../../../consts/consts';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'app-employer-additional-contact-form-grid',
  templateUrl: './employer-additional-contact-form-grid.component.html',
  styleUrls: ['./employer-additional-contact-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerAdditionalContactFormGridComponent implements OnInit {
  private destroyRef = inject(DestroyRef);

  @Input({ required: true }) form!: EmployerAdditionalContactFormGroup | EmployerRecordAdditionalContactFormGroup;
  @Input() index: number = 0;
  @Input() formSubmitted: boolean = false;
  @Input() countryCodeDropdowns: PhoneDropdownItem[] = [];
  @Input() controlIdPrefix: string = '';

  public customErrorMessages = {
    firstName: {
      required: $localize`First Name required`
    },
    lastName: {
      required: $localize`Last Name required`
    },
    contactTopic: {
      required: $localize`Contact Topic required`,
      maxlength: $localize`Contact Topic must be no more than 40 characters`
    },
    email: {
      required: $localize`Email required`
    },
    phoneNumber: {
      required: $localize`Phone Number required`
    }
  };

  public ngOnInit(): void {
    this.form.controls.hasSigningAuthority.valueChanges
      .pipe(startWith(this.form.controls.hasSigningAuthority.value), takeUntilDestroyed(this.destroyRef))
      .subscribe(hasSigningAuthority => {
        if (hasSigningAuthority) {
          this.form.controls.address.enable();
        } else {
          this.form.controls.address.reset({ countryId: CANADA_COUNTRY_ID });
          this.form.controls.address.disable();
        }
      });
  }
}
